import type { FontFace } from '../../theme';

import type { ReactNode, ElementType } from 'react';

import clsx from 'clsx';

type TypographyProps = {
  className?: string;
  children: ReactNode;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  fontFace?: FontFace;
};

const Title = ({
  className,
  children,
  level = 1,
  fontFace
}: TypographyProps) => {
  const Tag: ElementType = `h${level}`;
  const fonts = `text-${fontFace}`;

  return (
    <Tag className={clsx(fonts, className ? className : '')}>{children}</Tag>
  );
};

const Text = ({ className, children, fontFace }: TypographyProps) => {
  const fonts = `text-${fontFace}`;

  return (
    <span className={clsx(fonts, className ? className : '')}>{children}</span>
  );
};

const Paragraph = ({ className, children, fontFace }: TypographyProps) => {
  const fonts = `text-${fontFace}`;

  return <p className={clsx(fonts, className ? className : '')}>{children}</p>;
};

const Typography = ({ className, children, fontFace }: TypographyProps) => {
  const fonts = `text-${fontFace}`;

  return (
    <span className={clsx(fonts, className ? className : '')}>{children}</span>
  );
};

Typography.Paragraph = Paragraph;

Typography.Text = Text;

Typography.Title = Title;

export { Typography };
export type { TypographyProps };
